import React from 'react';
import { QUERY_KEYS, vatTuSearchColumns, warehouseSearchColumns } from '@/constants';
import type { SearchFieldState, SearchFieldActions } from '../../hooks';
import { SearchFieldV2 as SearchField } from '@/components/custom/erp';
import { KhoHang, VatTu } from '@/types/schemas';
import { Label } from '@/components/ui/label';

interface DetailTabProps {
  state: SearchFieldState;
  action: SearchFieldActions;
}

const DetailTab = ({ state, action }: DetailTabProps) => {
  return (
    <div className='p-4'>
      {/* Mã vật tư */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Mã vật tư</Label>
        <SearchField<VatTu>
          type='text'
          name='ma_vt'
          searchEndpoint={`/${QUERY_KEYS.VAT_TU}/`}
          searchColumns={vatTuSearchColumns}
          columnDisplay='ma_vt'
          displayRelatedField='ten_vt'
          dialogTitle='Danh mục vật tư'
          onRowSelection={action.setVattu}
          value={state.vatTu?.ma_vt}
          relatedFieldValue={state.vatTu?.ten_vt}
          className='w-100'
        />
      </div>

      {/* Mã kho */}
      <div className='flex items-center'>
        <Label className='w-[150px]'>Mã kho</Label>
        <SearchField<KhoHang>
          type='text'
          name='ma_kho'
          searchEndpoint={`/${QUERY_KEYS.KHO_HANG}/`}
          searchColumns={warehouseSearchColumns}
          columnDisplay='ma_kho'
          displayRelatedField='ten_kho'
          dialogTitle='Danh mục kho hàng'
          onRowSelection={action.setKho}
          value={state.kho?.ma_kho}
          relatedFieldValue={state.kho?.ten_kho}
          className='w-100'
        />
      </div>
    </div>
  );
};

export default DetailTab;
